// longitude = d'est en ouest
// latitude = du nord au sud

const placeCardTemplate = document.getElementById('mm-map-place-template');
const placesContainer = document.getElementById('mm-map-places');
const showroomsContainer = placesContainer.querySelector("#mm-map-showrooms");
const storesContainer = placesContainer.querySelector("#mm-map-stores");
const placesJSONEl = document.querySelector('#mm-places-json .metafield-json');
const mapboxTokenInput = document.getElementById('mm-mapbox-token');
const geocoderWrapper = document.querySelector(".mm-places-wrapper #mm-map-geocoder");
const visiblePlacesCount = document.getElementById("mm-map-visible-places-count");

const PLACE_SELECTED_CLASS = 'selected';
const MARKER_DEFAULT_COLOR = '#ffffff';
const MARKER_SELECTED_COLOR = '#000000';
const STORE_MARKER_URL = document.getElementById('mmMapMarker2').value;
const SHOWROOM_MARKER_URL = document.getElementById('mmMapMarker1').value;
const FLY_TO_PLACE_ON_CLICK_ON_CARD = false;
const FLY_TO_PLACE_ON_CLICK_ON_MARKER = false;
const CENTER_MAP_ON_MARKER_ON_CLICK_ON_CARD = true;
const MAP_STYLE = document.getElementById('mmMapSkin').value;

//console.log(document.getElementById('mmMapSkin'));

class Place {
  constructor(placeData) {
    this.name = placeData.name;
    this.address = placeData.address;
    this.coordinates = [placeData.Longitude, placeData.Latitude];
    this.address_complement = placeData.address_complement;
    this.calendly_link = placeData.calendly_link;
    this.type = placeData.type;
    this.country = placeData.country;
    this.info = placeData.info;
  }

  get isShowroom() {
    return this.type === "showroom";
  }

  get isStore() {
    return this.type === "store";
  }

  get listContainer() {
    if (this.isStore) {
      return storesContainer;
    }
    return showroomsContainer;
  }

  get markerIconUrl() {
    if (this.isShowroom) {
      return SHOWROOM_MARKER_URL;
    }
    return STORE_MARKER_URL;
  }

  buildPopup() {
    var showroomName = document.getElementById('mmMapTitle1').value;
    var storeName = document.getElementById('mmMapTitle2').value;

    if(this.type == "store"){var markerType = storeName}else{var markerType = showroomName};
    if(this.calendly_link != null){
      return new mapboxgl.Popup().setHTML(`
      <div>
        <p style="font-weight:bold">${this.name}</p>
        <p>${markerType}</p>
        <p>${this.address}</p>
        <p>${this.address_complement || ''}</p>
        <p style="text-weight:bold;font-size: 13px">${this.info || ''}</p>
        <a class="mm-btn-map-card" href="${this.calendly_link}">Prendre RDV</a>
      </div>
      `);
    } else {
      return new mapboxgl.Popup().setHTML(`
      <div>
        <p style="font-weight:bold">${this.name}</p>
        <p>${markerType}</p>
        <p>${this.address}</p>
        <p>${this.address_complement || ''}</p>
        <p style="text-weight:bold;font-size: 13px">${this.info || ''}</p>
      </div>
      `);
    }

  }
}

mapboxgl.accessToken = mapboxTokenInput.value;
const places = JSON.parse(placesJSONEl.innerText).map(placeData => new Place(placeData));
const placesByType = { showroom: [], store: [] }
places.forEach(place => placesByType[place.type].push(place));

function mmInsertPlaceCard(place) {
  // console.log('place:', place);
  const card = placeCardTemplate.content.cloneNode(true).firstElementChild;

  const nameEl = card.querySelector('[data-place-name]');
  nameEl.textContent = place.name;

  const addressEl = card.querySelector('[data-place-address]');
  addressEl.textContent = place.address;

  const addressComplementEl = card.querySelector('[data-place-address-complement]');
  addressComplementEl.textContent = place.address_complement;

  const calendlyEl = card.querySelector('[data-place-calendly]');
  if (place.type == "showroom") {
    if(place.calendly_link == null) {
      calendlyEl.style.display = "none";
    } else {
      calendlyEl.href = place.calendly_link;
    }
  } else {
    calendlyEl.style.display = "none";
  }

  const infoEl = card.querySelector('[data-place-info]');
  if(place.info != null){
    infoEl.innerHTML = place.info;
  }

  card.dataset.placeCoordinates = JSON.stringify(place.coordinates);

  place.listContainer.appendChild(card);
}

function mmDisplayVisibleMarkers(map) {
    var showroomName = document.getElementById('mmMapTitle1').value;
    var storeName = document.getElementById('mmMapTitle2').value;

  // const { _ne: NorthEast, _sw: SouthWest } = map.getBounds();
  // const maxNorth = NorthEast.lat;
  // const maxEast = NorthEast.lng;
  // const maxSouth = SouthWest.lat;
  // const maxWest = SouthWest.lng;
  // same with destructuring:
  const {
    _ne: { lng: maxEast, lat: maxNorth },
    _sw: { lng: maxWest, lat: maxSouth }
  } = map.getBounds();

  let sumVisibleStores = 0;
  let placesByType = { showroom: [], store: [] };
  places.forEach((place) => {
    // const lng = places.coordinates.lng;
    // const lat = places.coordinates.lat;
    const [lng, lat] = place.coordinates; // [-1.557900, 47.214370]

    const visible = lng < maxEast &&
      lng > maxWest &&
      lat > maxSouth &&
      lat < maxNorth

    if (visible) {
      if (place.isShowroom) {
        sumVisibleStores += 1;
        placesByType[place.type].push(place)
      } else {
        sumVisibleStores += 1;
        placesByType[place.type][place.country] ||= [];
        placesByType[place.type][place.country].push(place)
      }
    }
  });
  // update stores counter
  if (sumVisibleStores > 0) {
    visiblePlacesCount.innerText = `${sumVisibleStores} boutique${sumVisibleStores > 1 ? 's' : ''}`;
  } else {
    visiblePlacesCount.innerText = "Aucune boutique dans cette zone."
  }
  // insert showroom
  if (placesByType.showroom.length) { // display section title only if some showrooms are present
    showroomsContainer.insertAdjacentHTML('beforeend', `<p>Nos ${showroomName}</p>`);
  }
  placesByType.showroom.forEach(mmInsertPlaceCard);
  // insert stores by country
  Object.keys(placesByType.store).forEach((country) => {
    const places = placesByType.store[country];
    storesContainer.insertAdjacentHTML('beforeend', `<p>Nos ${storeName} en ${country}</p>`);
    places.forEach(mmInsertPlaceCard);
  });
}

function mmFlyToPlaceByCoordinates(coordinates) {
  const map = window.mmMap;
  map.flyTo(
    { center: coordinates, zoom: 15 },
    { placeCoordinatesToSelect: coordinates }
  );
}

function mmCenterPlaceMarkerOnMap(coordinates) {
  const map = window.mmMap;
  map.flyTo(
    { center: coordinates },
    { placeCoordinatesToSelect: coordinates }
  );
}

function mmSelectPlaceByCoordinates(coordinates) {
  const placeCards = placesContainer.querySelectorAll(".mm-map-place-card");
  Array.from(placeCards).forEach((placeCard) => {
    placeCard.classList.remove(PLACE_SELECTED_CLASS);

    const [cardLng, cardLat] = JSON.parse(placeCard.dataset.placeCoordinates);
    const [lng, lat] = coordinates;
    if (cardLng === lng && cardLat === lat) {
      placeCard.classList.add(PLACE_SELECTED_CLASS);
    }
  });

  mmHighLightPlaceMarkerByCoordinates(coordinates);
}

function mmHighLightPlaceMarkerByCoordinates(coordinates) {
  const [lng, lat] = coordinates;
  const markers = document.querySelectorAll('#mm-map [data-marker-place-coordinates]');

  markers.forEach((marker) => {
    const [markerLng, markerLat] = JSON.parse(marker.dataset.markerPlaceCoordinates);
    const markerPath = marker.querySelector('path');

    // won't work with custom markers
    if (markerPath && markerLng === lng && markerLat === lat) {
      markerPath.setAttribute('fill', MARKER_SELECTED_COLOR);
    } else if (markerPath) {
      markerPath.setAttribute('fill', MARKER_DEFAULT_COLOR);
    }
  })
}

function mmInitMap() {
  const map = new mapboxgl.Map({
    container: 'mm-map', // container ID
    style: MAP_STYLE, // style URL
    center: [2.25, 46.45], // starting position [lng, lat]
    zoom: 1, // starting zoom
  });

  window.mmMap = map;

  // Add geocoded search in seperated div
  // https://docs.mapbox.com/mapbox-gl-js/example/mapbox-gl-geocoder-outside-the-map/
  const geocoder = new MapboxGeocoder({
    mapboxgl: mapboxgl,
    accessToken: mapboxgl.accessToken,
    //countries: 'fr,gf' // comma separated list
  });
  geocoderWrapper.appendChild(geocoder.onAdd(map));


  // Add geolocate control to the map.
  map.addControl(
    new mapboxgl.GeolocateControl({
      positionOptions: {
      enableHighAccuracy: true
    },
    // When active the map will receive updates to the device's location as it changes.
    trackUserLocation: true,
    // Draw an arrow next to the location dot to indicate which direction the device is heading.
    showUserHeading: true
    })
  );

  places.forEach((place) => {
    const customMarker = document.createElement("div")
    customMarker.innerHTML = `
    <div class="mm-map-marker mm-map-marker-${place.type}">
      <img height="30" width="30" alt="marker" src="${place.markerIconUrl}"/>
    </div>
    `

    const marker = new mapboxgl.Marker(customMarker)
      .setLngLat(place.coordinates)
      .setPopup(place.buildPopup())
      .addTo(map);
    const markerElement = marker.getElement();

    markerElement.dataset.markerPlaceCoordinates = JSON.stringify(place.coordinates);

    if (FLY_TO_PLACE_ON_CLICK_ON_MARKER) {
      markerElement.addEventListener('click', () => {
        mmFlyToPlaceByCoordinates(place.coordinates);
      });
    }
  });

  mmDisplayVisibleMarkers(map);

  map.on('moveend', (event) => {
    showroomsContainer.innerHTML = null;
    storesContainer.innerHTML = null;

    mmDisplayVisibleMarkers(map);

    // if move was triggered by mmFlyToPlaceByCoordinates, highlight card in list
    if (event.placeCoordinatesToSelect) {
      mmSelectPlaceByCoordinates(event.placeCoordinatesToSelect);
    }
  });

  placesContainer.addEventListener('click', (event) => {
    const target = event.target;

    const card = target.closest('.mm-map-place-card');
    if (card) {
      const coordinates = JSON.parse(card.dataset.placeCoordinates);
      if (FLY_TO_PLACE_ON_CLICK_ON_CARD && !CENTER_MAP_ON_MARKER_ON_CLICK_ON_CARD) {
        mmFlyToPlaceByCoordinates(coordinates);
      }
      if (CENTER_MAP_ON_MARKER_ON_CLICK_ON_CARD) {
        mmCenterPlaceMarkerOnMap(coordinates);
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', mmInitMap);

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
  };
